import {
  CREATE_BRANCH_START,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAILED,
  UPDATE_BRANCH_START,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAILED,
  DELETE_BRANCH_START,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAILED,
  FETCH_BRANCHES_START,
  FETCH_BRANCHES_SUCCESS,
  FETCH_BRANCHES_FAILED,
  FETCH_USERS_BRANCHES_START,
  FETCH_USERS_BRANCHES_SUCCESS,
  FETCH_USERS_BRANCHES_FAILED,
  CLEAR_BRANCH_ERROR

} from "../store/types";

const INITIAL_STATE = {
  branches: [],
  currentBranch: null,
  currentUserBranch: null,
  completed: false,
  loading: false,
  success: false,
  error: {
    flag: false,
    msg: null
  },





}

export const branchesreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case CREATE_BRANCH_START:
      return {
        ...state,
        loading: true,
        completed: false,
        success: false,

      }

    case FETCH_USERS_BRANCHES_SUCCESS:
      return {
        ...state,
        loading: true,
        completed: false,
        success: false,
        currentUserBranch: action.payload
      }

    case CREATE_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        completed: true,
        success: true,

        branches: [...state.branches, ...action.payload],
        currentBranch: action.payload,
      }

    case CREATE_BRANCH_FAILED:
      return {
        ...state,
        loading: false,
        completed: true,
        success: false,
        error: {
          flag: true,
          msg: action.payload
        }
      }


    case FETCH_BRANCHES_START:
      return {
        ...state,
        loading: true,
        completed: false,
        success: false,

      }

    case FETCH_BRANCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        branches: action.payload,

      }

    case FETCH_BRANCHES_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      }

    case CLEAR_BRANCH_ERROR:
      return {
        ...state,
        completed: false,
        loading: false,
        success: false,
        error: {
          flag: false,
          msg: null
        }
      }
    case UPDATE_BRANCH_START:
      return {
        ...state,
        loading: true,
        error: null, // Reset error on new update attempt
      };

    case UPDATE_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        branches: state.branches.map(branch =>
          branch.branchId === action.payload.branchId
            ? { ...branch, ...action.payload }
            : branch
        ),
        error: null, // Clear any previous errors
      };

    case UPDATE_BRANCH_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error, // Set the error message
      };

    case DELETE_BRANCH_START:
      return {
        ...state,
        loading: true,

      };

    case DELETE_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        branches: state.branches.filter(
          (branch) => branch.branchId !== action.payload.branchId
        ),
        error: null,
      };

    case DELETE_BRANCH_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    default:
      return state;
  }
};